import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';

const Rit = ({ goalName, goalScore, expandFn, goal, currentTestEvent, instructionalAreaStrength }) => {
    Rit.propTypes = {
        goalName: PropTypes.string.isRequired,
        goalScore: PropTypes.number.isRequired,
        goal: PropTypes.instanceOf(Immutable.List).isRequired,
        currentTestEvent: PropTypes.object.isRequired,
        instructionalAreaStrength: PropTypes.string.isRequired,
    };
    /*
     * If this Rit component is (instructionalAreaStrength), check if we're in batch print.
     * If __BATCH__, don't use flexbox. Instead, surround the instructionalAreaStrength block w/ divs and use div for its element
     * If not batch, use <span> elements and defer to the flexbox styling.
     *
     * Prefer diverging the DOM between screen/print and batch because flexbox allows much better looking vertical centering.
     */
    return (
        <div
            className="ia-entry-wrapper ia-rit-only"
            onClick={(event) => expandFn(event, goal, currentTestEvent, 'instructional-areas')}
        >
            <div className="ia-score">{goalScore}</div>
            <div className="ia-name">{goalName}</div>
            <span className="icon icon-action-arrow-right ia-arrow"></span>

            {instructionalAreaStrength != '' ? (
                __BATCH__ ? (
                    <div>
                        <div className="icon-focus ia-strength ">{instructionalAreaStrength}</div>
                    </div>
                ) : (
                    <span className="icon-focus ia-strength ">{instructionalAreaStrength}</span>
                )
            ) : null}
        </div>
    );
};
export default Rit;
